/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3FormInput from '@Uilib/h3FormInput';
import ExpenseActions from '@Actions/purchase/expense/expenseActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import './style.scss';

/**
 *
 */
const ExpenseAccountForm = ({
  user, createAccount, createAccountLoading, callback, selectedAccount, updateAccount, updateAccountLoading,
}) => {
  const [accountName, setAccountName] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    if (selectedAccount) {
      setAccountName(selectedAccount?.account_name);
    }
  }, []);

  const addExpenseAccount = () => {
    setFormSubmitted(true);
    if (accountName) {
      if (selectedAccount) {
        const payload = {
          account_name: accountName,
          account_id: selectedAccount?.account_id,
        };
        updateAccount(payload, (createdAccount) => {
          if (callback) callback(createdAccount);
        });
      } else {
        const payload = {
          account_name: accountName,
          tenant_id: user?.tenant_info?.tenant_id,
        };
        createAccount(payload, (createdAccount) => {
          if (callback) callback(createdAccount);
        });
      }
    }
  };

  return (
    <div className="ant-row">
      <div className="ant-col-md-24 ant-col-xs-24">
        <H3FormInput
          name="expense account"
          type="text"
          containerClassName="orgInputContainer"
          labelClassName="orgFormLabel"
          inputClassName="gst__input-add-product orgFormInput"
          placeholder=""
          onChange={(event) => setAccountName(event.target.value)}
          value={accountName}
          label="Expense Account"
          required
          showError={formSubmitted && !(accountName)}
          maxlength="50"
        />
      </div>
      <div className="ant-col-md-12" style={{ marginTop: '0.5rem' }}>
        <H3Button
          buttonType={defaultButtonTypes.BLUE_ROUNDED}
          text={selectedAccount ? 'Update Account' : 'Add Account'}
          onClick={() => addExpenseAccount()}
          isLoading={createAccountLoading || updateAccountLoading}
          disabled={createAccountLoading || updateAccountLoading}
          style={{
            width: '200px',
            borderRadius: '5px',
            padding: '7px 0px',
            marginLeft: '0',
          }}
        />
      </div>
    </div>
  );
};

const mapStateToProps = ({
  UserReducers, ExpenseReducers,
}) => ({
  user: UserReducers.user,
  createAccountLoading: ExpenseReducers.createAccountLoading,
  updateAccountLoading: ExpenseReducers.updateAccountLoading,
});
const mapDispatchToProps = (dispatch) => ({
  createAccount: (payload, callback) => dispatch(ExpenseActions.createAccount(payload, callback)),
  updateAccount: (payload, callback) => dispatch(ExpenseActions.updateAccount(payload, callback)),
});

ExpenseAccountForm.propTypes = {
  user: PropTypes.any,
  createAccountLoading: PropTypes.bool,
  updateAccountLoading: PropTypes.bool,
  callback: PropTypes.any,
  selectedAccount: PropTypes.any,
  createAccount: PropTypes.func,
  updateAccount: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ExpenseAccountForm));
